export enum ParamType {
	BOOLEAN = 'boolean',
	BUTTON = 'button',
	COLOR = 'color',
	FLOAT = 'float',
	FOLDER = 'folder',
	INTEGER = 'integer',
	OPERATOR_PATH = 'operator_path',
	PARAM_PATH = 'param_path',
	NODE_PATH = 'node_path',
	RAMP = 'ramp',
	SEPARATOR = 'separator',
	STRING = 'string',
	VECTOR2 = 'vector2',
	VECTOR3 = 'vector3',
	VECTOR4 = 'vector4',
}
// export type ParamTypeKey = ParamType
// export type ParamTypeKeysArray = Array<ParamTypeKey>
// const ParamTypeKeysArray: ParamTypeKeysArray = [ParamType.BOOLEAN]
